import {Component, OnInit} from '@angular/core';
import {Project} from "../../../models/project.model";
import {ProjectCategory} from "../../../models/project-category.model";
import {map, Observable, Subscription} from "rxjs";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {UploadService} from "../../../services/upload.service";
import {Demokratiewerkstatt, DemokratiewerkstattCategory} from "../../../models/demokratiewerkstatt.model";
import {DemokratiewerkstattService} from "../../../services/demokratiewerkstatt.service";
import {DemokratiewerkstattCategoryService} from "../../../services/demokratiewerkstatt-category.service";

@Component({
  selector: 'app-demokratiewerkstatt-edit',
  templateUrl: './demokratiewerkstatt-edit.component.html',
  styleUrls: ['./demokratiewerkstatt-edit.component.css']
})
export class DemokratiewerkstattEditComponent implements OnInit {
  public showSpinner: boolean = false;

  public demokratiewerkstatt: Demokratiewerkstatt;
  public logoFile: File[] = [];
  public imageDemokratiewerkstatt: File[] = [];
  public sponsorImages: File[] = [];
  public partnerImages: File[] = [];
  public categories: DemokratiewerkstattCategory[] = [];
  public categorySubscription$: Subscription;
  public array: any = [];
  arrayTest: any = [];

  demokratiewerkstattForm: FormGroup;
  demokratiewerkstattPreview$: Observable<Demokratiewerkstatt>;

  previewLogoDemokratiewerkstatt: string = '';
  previewDemokratiewerkstattImage: string = '';
  previewSponsorImage: any[] = [];
  previewPartnerImage: any[] = [];

  projectCategory: ProjectCategory;

  constructor(
    private readonly _fb: FormBuilder,
    private readonly _demokratiewerkstattService: DemokratiewerkstattService,
    private readonly router: Router,
    private readonly uploadService: UploadService,
    private readonly route: ActivatedRoute,
    private readonly _demokratiewerkstattCategoryService: DemokratiewerkstattCategoryService
  ) {
  }

  get contentControl() {
    return this.demokratiewerkstattForm.controls['content'] as FormControl;
  }

  ngOnInit(): void {
    this._demokratiewerkstattCategoryService.getAllCategorys();
    window.scrollTo(0, 0);
    this.categorySubscription$ =
      this._demokratiewerkstattCategoryService.DemokratiewerkstattCategorySubject.subscribe(
        (response: any) => {
          this.categories = response;
          this.array = response;
        }
      );
    const id = +this.route.snapshot.params['id'];
    this._demokratiewerkstattService.getDemokratiewerkstatt(id).subscribe((response: Demokratiewerkstatt): void => {
      this.demokratiewerkstatt = response;
      this.demokratiewerkstatt.sponsor_images_url =
        this._demokratiewerkstattService.convertStringToArray(response.sponsor_images_url);
      this.demokratiewerkstatt.partners_images_url =
        this._demokratiewerkstattService.convertStringToArray(response.partners_images_url);
      this.initForm(this.demokratiewerkstatt);

      this.demokratiewerkstattPreview$ = this.demokratiewerkstattForm.valueChanges.pipe(
        map((formValue) => ({
          ...formValue,
        }))
      );
    });
  }

  initForm(demokratiewerkstatt: Demokratiewerkstatt): void {
    this.demokratiewerkstattForm = this._fb.group({
      title: [demokratiewerkstatt.title, Validators.required],
      content: [demokratiewerkstatt.content, Validators.required],
      demokratiewerkstatt_icon_url: [demokratiewerkstatt.demokratiewerkstatt_icon_url],
      demokratiewerkstatt_image_url: [demokratiewerkstatt.demokratiewerkstatt_image_url],
      sponsor_images_url: [demokratiewerkstatt.sponsor_images_url],
      partners_images_url: [demokratiewerkstatt.partners_images_url],
      director: [demokratiewerkstatt.lead],
      code: [demokratiewerkstatt.code],
      start_date: [demokratiewerkstatt.start_date],
      end_date: [demokratiewerkstatt.end_date],
      location: [demokratiewerkstatt.location],
    });
  }

  removeImage(url: string, type: string): void {
    switch (type) {
      case 'icon':
        this.demokratiewerkstattForm.get('demokratiewerkstatt_icon_url')?.patchValue('');
        break;
      case 'cover':
        this.demokratiewerkstattForm.get('demokratiewerkstatt_image_url')?.patchValue('');
        break;
      case 'sponsor':
        const sponsorImagesUrl = this.demokratiewerkstattForm.get('sponsor_images_url')
          ?.value as string[];
        const filteredSponsorImagesUrl = sponsorImagesUrl.filter(
          (imageUrl) => imageUrl !== url
        );
        this.demokratiewerkstattForm
          .get('sponsor_images_url')
          ?.patchValue(filteredSponsorImagesUrl);
        break;
      case 'partner':
        const parnerImagesUrl = this.demokratiewerkstattForm.get('partners_images_url')
          ?.value as string[];
        const filteredPartnerImagesUrl = parnerImagesUrl.filter(
          (imageUrl) => imageUrl !== url
        );
        this.demokratiewerkstattForm
          .get('partners_images_url')
          ?.patchValue(filteredPartnerImagesUrl);
        break;
      default:
        console.log('Invalid image type');
    }
  }

  async submitForm() {
    this.showSpinner = true;
    if (this.logoFile.length !== 0) {
      const logoPayload = this.cloudinaryRequestFormatter(this.logoFile[0]);
      let logoResponse: any = await this.sentToCloudinary(logoPayload)
      this.demokratiewerkstattForm.get('demokratiewerkstatt_icon_url')?.patchValue(logoResponse.secure_url);
      this.demokratiewerkstattForm.get('demokratiewerkstatt_icon_url')?.updateValueAndValidity();
    }

    if (this.imageDemokratiewerkstatt.length !== 0) {
      const bannerPayload = this.cloudinaryRequestFormatter(this.imageDemokratiewerkstatt[0]);
      let bannerResponse: any = await this.sentToCloudinary(bannerPayload);
      this.demokratiewerkstattForm.get('demokratiewerkstatt_image_url')?.patchValue(bannerResponse.secure_url);
      this.demokratiewerkstattForm.get('demokratiewerkstatt_image_url')?.updateValueAndValidity();
    }

    if (this.sponsorImages.length !== 0) {
      const imageUrls: any = [];

      for (let file of this.sponsorImages) {
        let sponsorImagePayload = this.cloudinaryRequestFormatter(file);
        let sponsorImagesResponse: any = await this.sentToCloudinary(sponsorImagePayload);
        if (this.demokratiewerkstattForm.value.sponsor_images_url.length <= 3) {
          this.demokratiewerkstattForm.value.sponsor_images_url.push(sponsorImagesResponse.secure_url);
        }
      }
      this.demokratiewerkstattForm.get('sponsor_images_url')?.updateValueAndValidity();
    }

    if (this.partnerImages.length !== 0) {
      const imageUrls: any = [];

      for (let file of this.partnerImages) {
        let partnerImagePayload = this.cloudinaryRequestFormatter(file);
        let partnerImageResponse: any = await this.sentToCloudinary(partnerImagePayload);
        imageUrls.push(partnerImageResponse.secure_url);
        if (this.demokratiewerkstattForm.value.partners_images_url.length <= 6) {
          this.demokratiewerkstattForm.value.partners_images_url.push(partnerImageResponse.secure_url);
        }
      }
      this.demokratiewerkstattForm.get('partners_images_url')?.updateValueAndValidity();
    }
    this.submitHandler();
    this.showSpinner = false;
  }

  cloudinaryRequestFormatter(payload: any): FormData {
    const cloudinaryFormData = new FormData();
    cloudinaryFormData.append('file', payload);
    cloudinaryFormData.append('upload_preset', 'vmdo-project');
    cloudinaryFormData.append('cloud_name', 'kaeyros-cloudinary');
    return cloudinaryFormData;
  }

  submitHandler() {
    const formValue = this.demokratiewerkstattForm.value;
    const demokratiewerkstatt: Demokratiewerkstatt = {
      title: formValue['title'],
      content: formValue['content'],
      start_date: formValue['start_date'],
      end_date: formValue['end_date'],
      location: formValue['location'],
      demokratiewerkstatt_icon_url: formValue['demokratiewerkstatt_icon_url'],
      demokratiewerkstatt_image_url: formValue['demokratiewerkstatt_image_url'],
      sponsor_images_url: formValue['sponsor_images_url'],
      partners_images_url: formValue['partners_images_url'],
      lead: formValue['director'],
      code: formValue['code'],
      partners_images_urls: formValue['partners_images_urls'],
    };

    if (formValue['demokratiewerkstatt_icon_url'].length > 0) {
      demokratiewerkstatt.demokratiewerkstatt_icon_url = formValue['demokratiewerkstatt_icon_url'];
    } else {
      demokratiewerkstatt.demokratiewerkstatt_icon_url = ' ';
    }

    if (formValue['demokratiewerkstatt_image_url'] !== '') {
      demokratiewerkstatt.demokratiewerkstatt_image_url = formValue['demokratiewerkstatt_image_url'];
    } else {
      demokratiewerkstatt.demokratiewerkstatt_image_url = ' ';
    }

    if (formValue['sponsor_images_url'].length > 0) {
      demokratiewerkstatt.sponsor_images_url = formValue['sponsor_images_url'];
    } else {
      demokratiewerkstatt.sponsor_images_url = [''];
    }

    if (formValue['partners_images_url'].length > 0) {
      demokratiewerkstatt.partners_images_url = formValue['partners_images_url'];
    } else {
      demokratiewerkstatt.partners_images_url = [''];
    }

    this._demokratiewerkstattService
      .editProject(this.demokratiewerkstatt.id ?? 0, demokratiewerkstatt)
      .subscribe(
        (response) => {
          this._demokratiewerkstattService.getWorkshops();
          this._demokratiewerkstattService.emitDemokratiewerkstattSubject();
          formValue['demokratiewerkstatt_icon_url'];
          console.log(response);
          this.router.navigate([`/demokratiewerkstatt/${response.id}`]);
        },
        (error) => {
          console.error(`An error occured: ${error.message}`);
        }
      );

  }

  public cancelEdit(): void {
    this.router.navigateByUrl('/demokratiewerkstatt/list');
  }

  public onSelectLogo(event: any): void {
    this.logoFile.push(...event.addedFiles);
    const file = this.logoFile[0];
    if (file) {
      this.previewLogoDemokratiewerkstatt = '';
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.previewLogoDemokratiewerkstatt = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }

  public onRemoveLogo(event: any) {
    this.logoFile.splice(this.logoFile.indexOf(event), 1);
    this.previewLogoDemokratiewerkstatt = '';
  }

  public onSelectImageProject(event: any): void {
    this.imageDemokratiewerkstatt.push(...event.addedFiles);
    const file = this.imageDemokratiewerkstatt[0];
    if (file) {
      this.previewDemokratiewerkstattImage = '';
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.previewDemokratiewerkstattImage = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }

  public onRemoveImageProject(event: any): void {
    this.imageDemokratiewerkstatt.splice(this.imageDemokratiewerkstatt.indexOf(event), 1);
    this.previewDemokratiewerkstattImage = '';

  }

  public onSelectSponsorImage(event: any): void {
    if (this.sponsorImages.length < 3) {
      const remainingSlots = 3 - this.sponsorImages.length;
      if (remainingSlots > 0) {
        const addedFiles = event.addedFiles.slice(0, remainingSlots);
        this.sponsorImages.push(...addedFiles);
        const files = addedFiles;
        for (let i = 0; i < files.length; i++) {
          const file = files[i];
          const reader = new FileReader();
          reader.onload = () => {
            this.previewSponsorImage.push(reader.result as string);
          };
          reader.readAsDataURL(file);
        }
      }
    }
  }

  public onSelectParntnerImage(event: any): void {
    if (this.partnerImages.length < 6) {
      const remainingSlots = 6 - this.partnerImages.length;
      if (remainingSlots > 0) {
        const addedFiles = event.addedFiles.slice(0, remainingSlots);
        this.partnerImages.push(...addedFiles);
        const files = addedFiles;
        for (let i = 0; i < files.length; i++) {
          const file = files[i];
          const reader = new FileReader();
          reader.onload = () => {
            this.previewPartnerImage.push(reader.result as string);
          };
          reader.readAsDataURL(file);
        }
      }
    }
  }

  public onRemoveSponsorImage(event: any): void {
    this.sponsorImages.splice(this.sponsorImages.indexOf(event), 1);
    this.previewSponsorImage.splice(this.previewSponsorImage.indexOf(event), 1);
  }

  public onRemovePartnerImage(event: any): void {
    this.partnerImages.splice(this.partnerImages.indexOf(event), 1);
    this.previewPartnerImage.splice(this.previewPartnerImage.indexOf(event), 1);
  }

  public sentToCloudinary(data: any) {
    return new Promise((resolve, reject) => {
      this.uploadService.uploadImage(data).subscribe(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject();
        }
      );
    });
  }

}
